import { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext(null);

const MAX_COMPARE = 3;

export function CompareProvider({ children }) {
  const [items, setItems] = useState([]);

  const addToCompare = useCallback((opp) => {
    setItems(prev => {
      if (prev.length >= MAX_COMPARE) return prev;
      if (prev.some(i => i.opportunity_id === opp.opportunity_id)) return prev;
      return [...prev, opp];
    });
  }, []);

  const removeFromCompare = useCallback((oppId) => {
    setItems(prev => prev.filter(i => i.opportunity_id !== oppId));
  }, []);

  const clearCompare = useCallback(() => setItems([]), []);

  const isInCompare = useCallback((oppId) => {
    return items.some(i => i.opportunity_id === oppId);
  }, [items]);

  return (
    <CompareContext.Provider value={{ items, addToCompare, removeFromCompare, clearCompare, isInCompare, MAX_COMPARE }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error('useCompare must be used within CompareProvider');
  return ctx;
}
